import { render, staticRenderFns } from "./ArcePoliciesResumen.vue?vue&type=template&id=0d24a88f&"
import script from "./ArcePoliciesResumen.vue?vue&type=script&lang=js&"
export * from "./ArcePoliciesResumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports